import React, { useState } from 'react';

import { IconScout } from '@/components/ui/images/IconScout';
import { Text } from '@/components/ui/text/Text';
import { Divider } from '@/components/ui/separators';
import { colors } from '@/assets/styles/colors';


export interface CollapsibleSectionProps {
  title: string;
  count?: number;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  count,
  defaultExpanded = true,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const header = count !== undefined ? `${title} (${count})` : title;

  return (
    <div>
      <Divider />
      <button
        type="button"
        className="flex items-center justify-between w-full py-3"
        onClick={() => setIsExpanded((previous) => !previous)}
        aria-expanded={isExpanded}
      >
        <Text variant="body-medium" color={colors.primary.dash}>
          {header}
        </Text>
        <IconScout
          name="angleDown"
          size="md"
          color={colors.primary.dash}
          className={`transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
        />
      </button>
      {isExpanded && children}
    </div>
  );
};

export default CollapsibleSection;
